import React from 'react';
import './FloatingElements.css';

const FloatingElements = () => {
  return (
    <div className="floating-elements">
      <div className="floating-shape floating-shape-1"></div>
      <div className="floating-shape floating-shape-2"></div>
      <div className="floating-shape floating-shape-3"></div>
      <div className="floating-shape floating-shape-4"></div>
      <div className="floating-shape floating-shape-5"></div>
      <div className="floating-shape floating-shape-6"></div>
    </div>
  );
};

export default FloatingElements;